import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password, accountNumber] as const
const locationCredentialTypes = ['location-account-number'] as const

export type saiaCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const saiaDocumentTypes = [
  'delivery-photo',
  'detention-certificate',
  'invoice',
  'no-freight-certificate',
  'proof-of-delivery',
  'signed-bol',
  'storage-certificate',
  'storage-notification',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const saia: CarrierDef<saiaCredType> = {
  name: 'Saia LTL Freight',
  scac: 'saia',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed by 5pm',
      guaranteedByTime: '17:00',
    },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed by Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
    { id: 'volume', name: 'Volume' },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['account-number', 'accountNumber'],
    ['location-account-number', 'ref1'],
  ],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'profinder',
    'tracking',
    'documents',
  ],
  documentTypes: saiaDocumentTypes,
  credentialConfig: {
    'account-number': { hideFromFreightview: true, nonsensitive: true },
    'location-account-number': { customerIdentifier: true },
  },
}
